module.exports = __webpack_public_path__ + "static/media/og-default.9c1b8e46.png";